<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Técnico Autorizado</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedLaboratorio = !isCollapsedLaboratorio"
                       [attr.aria-expanded]="!isCollapsedLaboratorio" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedLaboratorio" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedLaboratorio" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="Laboratorio">Laboratorio</label>
                                <input formControlName="Laboratorio" name="Nombre" title=""
                                       class="form-control" id="Laboratorio" type="text" value="" [ngClass]="displayFieldCss('Laboratorio')" maxlength="50" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="Nif">NIF</label>
                                <input formControlName="Nif" name="Nif" title=""
                                       class="form-control" id="Nif" type="text" value="" [ngClass]="displayFieldCss('Nif')" maxlength="9">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Nif','required')">
                                    El NIF es obligatorio
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nif','NIF')">
                                    Formato de NIF incorrecto
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nif','nif_duplicated')">
                                    El NIF ya existe en la base de datos
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="NombreUsuario">Nombre</label>
                                <input formControlName="NombreUsuario" name="NombreUsuario" title=""
                                       class="form-control" id="NombreUsuario" type="text" value="" [ngClass]="displayFieldCss('NombreUsuario')" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('NombreUsuario','required')">
                                    El Nombre es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="ApellidosUsuario">Apellidos</label>
                                <input formControlName="ApellidosUsuario" name="ApellidosUsuario" title=""
                                       class="form-control" id="ApellidosUsuario" type="text" value="" [ngClass]="displayFieldCss('ApellidosUsuario')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('ApellidosUsuario','required')">
                                    Los Apellidos son obligatorios
                                </div>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpEmail">Email Persona Contacto</label>
                                <input formControlName="Email" name="Email" title=""
                                       class="form-control" id="inpEmail" type="text" [ngClass]="displayFieldCss('Email')" value="" maxlength="50">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','required')">
                                    Email es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Email','email')">
                                    Formato incorrecto
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpTelefono">Teléfono</label>
                                <input formControlName="Telefono" name="Telefono" title=""
                                       class="form-control" id="inpTelefono" type="text" [ngClass]="displayFieldCss('Telefono')" value="" maxlength="20">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Telefono','required')">
                                    El Teléfono es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpFechaCreacion">Fecha Creación</label>
                                <p-calendar formControlName="FechaCreacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpFechaActivacion">Fecha Activación</label>
                                <p-calendar formControlName="FechaActivacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpFechaBajaCampania">Fecha Baja</label>
                                <p-calendar formControlName="FechaBaja" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpActivo">Activo</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
